import React, { FC } from 'react';
import { IconType } from '@app/components/ui/icons/icon.type';

const WidgetHouse: FC<IconType> = (props) => {
  const { size, className, customStyle } = props;
  return (
    <div className={className}>
      <svg
        style={customStyle}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M3 12l9-9 9 9m-2 0v7a1 1 0 01-1 1h-4v-5h-2v5H8a1 1 0 01-1-1v-7" />
      </svg>
    </div>
  );
};

export default WidgetHouse;
